export enum APIType {
  ALTERNATIVE_DATES = 'alternativeDates',
  AUTOCOMPLETE = 'autocomplete',
  AVAILABILITY = 'availability',
  CLICK_HOTEL = 'clickHotel',
  COMPARE = 'compare',
  FILTERS = 'filters',
  PRODUCT = 'product',
  SEARCH_PROGRESS = 'searchProgress',
  SEARCH_PERIMETERS = 'searchPerimeters',
  TRANSPORT = 'transport',
  VIEW_HOTEL = 'viewHotel',
}

export enum Platform {
  APP = 'app',
  MEMSEARCH = 'memsearch',
  OPENX = 'openx',
  RTC = 'rtc',
}
